import { includes } from 'lodash'
import Meta from 'vue-meta'
import vueSmoothScroll from 'vue-smoothscroll'
import '@/utils/closestPolyfill.js'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Modules
import pagesStore from '@/modules/pages/_store'
import objectFitImages from 'object-fit-images'

Vue.use(vueSmoothScroll)
Vue.config.productionTip = false
objectFitImages()

/*
*  VUE FILTERS
*  ============
*/
Vue.filter('dynamic',
function (text) {
    /*
    * Replaces certain content with dynamic state content
    * usage: {{ stateString | dynamic }}
    * $options.filters.dynamic(intro.content)
    */
    const regex = /{{([^}]+)}}/g

    let dynamicText = text
    if (regex.test(text) || includes(text, '<a href="/')) {
        // Replace links to router links

        dynamicText = dynamicText.replace('<a href="/', '<router-link to="/')
        dynamicText = dynamicText.replace('</a>', '</router-link>')

        return dynamicText
    } else {
        return text
    }
}
)

Vue.filter('capitalize',
  function (text) {
      /*
       * Replaces floats with dot to a comma
       * usage: {{ stateString | europeanNumbers }}
       * $options.filters.europeanNumbers(intro.content)
       */

      if (text && text !== '') {
          return text.charAt(0).toUpperCase() + text.slice(1)
      }
      return text
  }
)

/*
*  VUE MODULES
*  ============
*/
store.registerModule('pages', pagesStore)

// store.subscribeAction((action, state) => {
//   console.log('action', action.type, action.payload)
// })
//
// store.subscribe((mutation, state) => {
//   console.log('mutation', mutation.type, mutation.payload)
// })

/*
*  VUE TRANSLATIONS
*  ============
*/
const vueApp = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    data: { translations: '' },
    async created () {
        const slug = this.$route.params.slug ? this.$route.params.slug : '/'
        let lang = this.$route.params.lang
        const browserLang = navigator.language || navigator.userLanguage || window.navigator.languages[0]
        let setLang

        if (browserLang === 'nl' || browserLang === 'nl-NL' || browserLang === 'nl-BE') {
            setLang = 'nl'
        } else if (browserLang === 'fr' || browserLang === 'fr-BE' || browserLang === 'fr-FR') {
            setLang = 'fr'
        } else setLang = 'en'

        if (this.$route.params.lang === undefined) {
            this.$router.push('/' + setLang)
            lang = setLang
        }

        this.$store.dispatch('getSeo', { slug: slug })

        await this.$store.dispatch('getGlobals', { lang: lang }).then(result => {
            this.translations = result
            return result
        }).then(() => {
            this.$store.commit('handleTranslations')
        })
    }
})

vueApp.install = function () {
    Object.defineProperty(Vue.prototype, '$globals', {
        get () {
            return vueApp.$store.state.globals
        }
    })
}

Vue.use(vueApp)

/*
*  VUE SEO DATA
*  ============
*/
Vue.use(Meta)
